import { Card, CardContent, Grid, Link, TextField, Typography } from '@material-ui/core';
import React from 'react';

interface IProps {
  qrCode: string;
  exhibitName: string;
  exhibitId?: string;
  onChange: (qrCode: string) => void;
}

const ExhibitQRCode: React.FC<IProps> = ({ qrCode, exhibitName, exhibitId, onChange }) => {
  var QRCode = require('qrcode.react');

  // Same address the server generates for a new exhibit.
  const generatedCode = exhibitId
    ? `${window.location.protocol}//${window.location.host}/qrCodes/${exhibitId}`
    : '';

  const downloadQR = () => {
    var svgData = document.getElementById('QRCode')?.outerHTML;
    var svgBlob = new Blob([svgData as BlobPart], {
      type: 'image/svg+xml;charset=utf-8',
    });
    var svgUrl = URL.createObjectURL(svgBlob);
    var downloadLink = document.createElement('a');
    downloadLink.href = svgUrl;
    downloadLink.download = `${exhibitName} QRCode.svg`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Card>
      <CardContent>
        <Grid item xs={12}>
          <Typography variant='subtitle2'>QR Code</Typography>
        </Grid>
        <Grid
          container
          item
          justify='center'
          direction='column'
          alignItems='center'
        >
          {qrCode ? (
            <>
              <QRCode
                id='QRCode'
                value={qrCode}
                level='H'
                size={225}
                renderAs={'svg'}
              />
              <Link
                component='button'
                type='button'
                onClick={downloadQR}
                style={{ marginTop: '10px', fontWeight: 'bold' }}
              >
                Download
              </Link>
            </>
          ) : (
            <Typography variant='body2' color='textSecondary'>
              A QR code is created when the exhibit is saved.
            </Typography>
          )}
          <TextField
            size='small'
            margin='normal'
            value={qrCode || ''}
            label='QR code link'
            name='qrCode'
            onChange={(e) => onChange(e.target.value)}
            helperText='To use a code that is already printed, paste the link it contains.'
            fullWidth
          />
          {generatedCode && qrCode !== generatedCode ? (
            <Link
              component='button'
              type='button'
              onClick={() => onChange(generatedCode)}
              style={{ fontWeight: 'bold' }}
            >
              Use this exhibit's own code
            </Link>
          ) : null}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ExhibitQRCode;
